import React from 'react';
import Button from '../../components/Button/button.js';
import Card from '../../components/Card/card.js';
import './espaceEtudiants.css';

export default function EspaceEtudiants() {

	const cartes = [
		{ image: "/images/haca.jpg", title: "Seminaire de formation" },
  	{ image: "/images/haca2.jpg", title: "Formation des animateurs avec la HACA" },
  	{ image: "/images/remise.jpg", title: "Celebrations de fin d'annee" },
  	{ image: "/images/sport.jpg", title: "Evénement sportif" },
		{ image: "/images/sport2.jpg", title: "Rencontre inter-école" },
	];

	return (
		<section className="text-rurale">
			<div className="container">
				<h1>Espace Etudiants</h1>
				<br />
				<div className="button">
					<Button style={{ padding: '1rem 4rem', fontSize: '1.5rem' }} onClick={() => window.open('https://www.qualireg.org/content/download/13752/191302/version/1/file/obj_10664_file_programme-de-microbiologie-Bts-bioac.pdf', '_blank')}>
						Ressources documentaires
					</Button>
					<Button style={{ padding: '1rem 4rem', fontSize: '1.5rem' }} onClick={() => window.open('https://escaccsanpedro.com/cours-en-ligne-etudiants/', '_blank')}>
						Cours en ligne
					</Button>
				</div>
				<h2>Activités Extrascolaires Universitaires 2025-2026</h2>
				<p>
					Chères étudiantes, chers étudiants,
				</p>	
				<p>
					Dans le cadre du renforcement de la vie étudiante et du développement des compétences personnelles et sociales, l'université lance deux activités majeures pour l'année académique 2025-2026. Ces initiatives visent à encourager l'engagement, la solidarité, l'esprit d'équipe et l'équilibre entre études et bien-être.
				</p>
				<h2>Programme CAFÉ – Ambassadeurs & Mentorat</h2>
				<p>
					L'université a l'honneur de rejoindre officiellement le Programme CAFÉ et offre à ses étudiants la possibilité de devenir Ambassadeur ou Mentor, deux rôles essentiels dans l'accompagnement scolaire et citoyen des jeunes.
				</p>
				<h3>Rôle de l'Ambassadeur du Programme CAFÉ</h3>
				<p>
					L'Ambassadeur est le représentant de l'université au sein du programme. Ses missions incluent :
				</p>
				<ul>
					<li>Promouvoir le Programme CAFÉ auprès des étudiants et partenaires internes.</li>
					<li>Participer à l'organisation et à l'animation d'activités éducatives ou citoyennes.</li>
					<li>Servir de relais entre l'université, le programme et les acteurs externes.</li>
					<li>Encourager l'engagement étudiant et faciliter la participation des volontaires.</li>
				</ul>
				<h3>Rôle du Mentor dans le Programme CAFÉ</h3>
				<p>
					Le Mentor accompagne directement un élève (collégien ou lycéen) pour renforcer sa réussite académique et personnelle. Ses tâches principales :
				</p>
				<ul>
					<li>Suivre régulièrement un élève, notamment en classe d'examen (BEPC, BAC…).</li>
					<li>Aider à la compréhension des cours, à l'organisation du travail et à la préparation des évaluations.</li>
					<li>Soutenir les élèves en difficulté et valoriser leurs progrès.</li>
					<li>Faciliter la motivation, la confiance en soi et la persévérance scolaire.</li>
				</ul>
				<h2>Séances de Football</h2>
				<p>
					Pour favoriser le bien-être, la cohésion et la détente, l'université organise des séances de football :
				</p>
				<ul>
					<li>📅 Tous les jeudis</li>
					<li>🕒 15h à 17h</li>
					<li>📍 Stade AUGUSTE DENISE</li>
				</ul>
				<p>
					Ces rencontres sportives sont ouvertes à toutes et tous, quel que soit le niveau, et permettent de développer l'esprit d'équipe dans une ambiance saine et conviviale.
				</p>
				<br />
				<div className="carousel-wrapper">
					<div className="carousel-uni" >
						  {cartes.map((carte, index) => (
						    <Card
						      key={`original-${index}`}
						      image={carte.image}
						      title={carte.title}
						      width="350px"
						      height="280px"
						      imageHeight="220px"
						      clickable={false}
						    />
						  ))}
						  {cartes.map((carte, index) => (
						    <Card
						      key={`duplicate-${index}`}
						      image={carte.image}
						      title={carte.title}
						      width="350px"
						      height="280px"
						      imageHeight="220px"
						      clickable={false}
						    />
						  ))}
					</div>
				</div>
			</div>
		</section>
	);
}
